/* eslint-disable prefer-const */
import { slugify } from '@techmely/utils'
import type { TOC } from '../post/post.types'
import type { TChapterCourse } from '~/features/course/course.types'

export const findCourseIndexBySlug = (
  slug: string,
  array: TChapterCourse[],
) => {
  for (let i = 0; i < array.length; i++) {
    const courses = array[i].courses
    const foundCourseIndex = courses.findIndex((course) => course.slug === slug)

    if (foundCourseIndex !== -1) {
      return i
    }
  }

  return -1
}

type TocHeader = {
  level: number
  title: string
}

export function generateTocContent(
  content: string,
  routerPath: string,
  includeFormatNumber = true,
): TOC[] {
  const headers = getHeadersFromContent(content)
  const toc = generateTocs(headers).map(({ title, level }, index) => {
    const originTitle = headers[index].title
    return {
      label: includeFormatNumber ? title : originTitle,
      to: `${routerPath}#${slugify(originTitle)}`,
      active: false,
      tagLevel: `H${level}`,
      exactHash: true,
    }
  })
  return toc
}

function getHeadersFromContent(content: string) {
  const headerRegex = /^(#+)\s*(.+)$/gm
  const headers: TocHeader[] = []
  let match: RegExpExecArray | null

  while ((match = headerRegex.exec(content)) !== null) {
    const matchTitle = match[0]
    const level = matchTitle.match(/^#+/)?.[0]?.length || 1
    const title = matchTitle.replace(/^#+\s/, '')
    headers.push({ level, title })
  }
  return headers
}

function generateTocs(headers: TocHeader[]) {
  let toc: TocHeader[] = []
  // Assuming up to 6 levels of headings
  let levelCounters = [0, 0, 0, 0, 0, 0]
  for (const header of headers) {
    const { level, title } = header
    levelCounters[level - 1]++
    for (let i = level; i < levelCounters.length; i++) {
      levelCounters[i] = 0
    }
    // Because we not includes H1 in the TOC --> We need to slice to 1 off array to exclude the H1
    const displayIndex = levelCounters.slice(1, level).join('.')
    const displayTitle = `${displayIndex}. ${title}`
    toc.push({
      level,
      title: displayTitle,
    })
  }

  return toc
}

export function extractSeoMarkdown(content: string) {
  const seoInfoReg = /^---\n(.*?\n)---/s
  const match = content.match(seoInfoReg)
  return match ? match[0].trim() : content
}
